import httpClient from '../../global/httpClient';
import * as apis from '../../constants/api';

export const getCourses = () => httpClient.get(apis.GET_DASHBOARD);

export const openUpCourse = (payload) =>
  httpClient.post(apis.POST_OPEN_UP_COURSE, { ...payload }, { ignore: true });
export const putOff = (payload) => httpClient.post(apis.POST_PUT_OFF, payload, { ignore: false });
export const preOpen = (payload) => httpClient.post(apis.POST_PRE_OPEN, payload, { ignore: false });

export const getReopenInfo = () => httpClient.get(apis.getReopenInfo());
export const reopenSubmit = (payload) => httpClient.post(apis.reopenSubmit(), payload);
